import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Button,
  CheckboxGroup,
  Checkbox,
  Uploader,
  Icon,
} from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import InputForm from '../../components/forms/input/InputForm'
import { isImageOrPdf, isRequired, isValidators } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { cloneDeep, isEmpty } from 'lodash-es'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import AppContext from '../../context/AppContext'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { v4 as uuidv4 } from 'uuid'
import notification from '../../utils/notification'
import {
  downloadFileSubproject,
  getProgressReportSubprojectClose,
  saveInnovations,
} from '../../redux/actions/progressReportSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'
import { downloadFile } from '../../utils/fileUtil'
import { getValueFromOptions } from '../../utils/dataUtil'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function HealthInnovationWidget({
  schema: _schema,
  isRole,
  isReadOnly,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  progressActivityId,
  setProgressReportsId = () => {},
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { theme } = React.useContext(AppContext)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressFilesValue, setProgressFilesValue] = useState([])
  const [deleteId, setDeleteId] = useState([])
  const defaultMaxFileSize = 50
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileTableData, setFileTableData] = useState([])
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)
    setProgressFilesValue(formSchema?.healthInnovation?.values || null)

    register('healthInnovationFiles', [])
    if (formSchema?.healthInnovation?.values && formSchema?.healthInnovation?.values?.length > 0) {
      setFileTableData(formSchema?.healthInnovation?.values)
    }
  }, [_schema])

  const onSubmit = (data) => {
    const formData = new FormData()
    formData.append('ProjectVersionId', projectVersionId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', period || '')
    formData.append('InstallmentPlanDetailId', installmentPlanId || '')
    if (deleteId.length > 0) {
      deleteId.forEach((id, index) => {
        formData.append(`DeleteInnovationsIds[${index}]`, id)
      })
    } else {
      formData.append('DeleteInnovationsIds', null)
    }

    let newArr = []
    for (const key in data) {
      console.log(`${key}: ${data[key]}`)

      if (key != 'healthInnovationFiles') {
        let keyArr = key.split('_')

        let keyName = keyArr[0]
        let keyIndex = Number(keyArr[1])
        let keyId = keyArr[2]

        formData.set(
          `InnovationsLists[${keyIndex}].Id`,
          keyId ? (keyId.indexOf('addNew-') === -1 ? keyId : '') : ''
        )

        if (keyName == 'healthInnovationName') {
          formData.set(`InnovationsLists[${keyIndex}].InnovationName`, data[key])
        }

        if (keyName == 'healthInnovationNature') {
          const innovationTypeValue = data[key] ? data[key].join(',') : ''
          formData.set(`InnovationsLists[${keyIndex}].InnovationType`, innovationTypeValue)
        }

        if (keyName == 'healthInnovationDetail') {
          formData.set(`InnovationsLists[${keyIndex}].InnovationDescription`, data[key])
        }

        if (keyName == 'healthInnovationUtilization') {
          formData.set(`InnovationsLists[${keyIndex}].InnovationUtilize`, data[key])
        }

        if (
          keyName == 'healthInnovationFiles' &&
          !isEmpty(data[key]) &&
          typeof data[key] != 'string'
        ) {
          data[key]?.forEach((element) => {
            formData.set(`InnovationsLists[${keyIndex}].InnovationFile`, element.blobFile)
          })
        } else if (
          keyName == 'healthInnovationFiles' &&
          !isEmpty(data[key]) &&
          typeof data[key] == 'string'
        ) {
          formData.set(`InnovationsLists[${keyIndex}].FilePathStr`, data[key])
        }
      }
    }

    handleCallService(formData)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveInnovations(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response.forms.otherOutcomes)
        setProgressFilesValue(response?.forms?.otherOutcomes?.healthInnovation?.values || null)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  const handleAdd = () => {
    let progressFilesVal = cloneDeep(progressFilesValue)
    progressFilesVal.push({
      id: 'addNew-' + uuidv4(),
      detailOfSocialfactors: '',
      envFlag: '',
    })

    setProgressFilesValue(progressFilesVal)
  }

  const handleDelete = (item, index) => {
    let progressFilesVal = cloneDeep(progressFilesValue)
    if (index > -1) {
      progressFilesVal.splice(index, 1)
    }
    if (!item.id.startsWith('addNew-')) {
      setDeleteId([...deleteId, item.id])
    }
    setProgressFilesValue(progressFilesVal)
  }

  const onDownload = async (path, name) => {
    startLoading()
    try {
      var file = await downloadFileSubproject(path)

      downloadFile(file, name)
    } catch (e) {
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
  }

  const setAlertMessage = (type, message) => {
    notification.open(type, {
      title: message,
      duration: 2500,
    })
  }

  return (
    <div>
      <Panel
        header={formSchema?.healthInnovation?.title}
        collapsible
        defaultExpanded
        style={{ marginTop: 10 }}
      >
        <div style={{ paddingLeft: 30, paddingRight: 10, marginTop: -20 }}>
          {progressFilesValue &&
            progressFilesValue.map((item, index) => {
              return (
                <>
                  <Panel collapsible defaultExpanded style={{ marginTop: 10 }}>
                    {formSchema?.healthInnovation?.healthInnovationName && (
                      <Row style={{ marginTop: 10 }}>
                        <Col lg={22} md={22} sm={22} xs={22}>
                          {!disabled ? (
                            <>
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    formSchema?.healthInnovation?.healthInnovationName?.validators
                                  ) && 'required'
                                )}
                              >
                                {`${formSchema.healthInnovation.healthInnovationName.label}`}
                              </ControlLabel>
                              <InputForm
                                schema={formSchema.healthInnovation.healthInnovationName}
                                name={`${formSchema.healthInnovation.healthInnovationName.name}_${index}_${item.id}`}
                                placeholder={
                                  'ระบุ' + formSchema.healthInnovation.healthInnovationName.label
                                }
                                value={item.healthInnovationName}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                                hideLabel={true}
                              />
                            </>
                          ) : (
                            <>
                              <b>{formSchema.healthInnovation.healthInnovationName.label}</b>
                              <p>{item.healthInnovationName}</p>
                            </>
                          )}
                        </Col>

                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>
                    )}
                    {formSchema?.healthInnovation?.healthInnovationNature && (
                      <Row style={{ marginTop: 10 }}>
                        <Col lg={22} md={22} sm={22} xs={22}>
                          {!disabled ? (
                            <>
                              <Controller
                                key={`${formSchema.healthInnovation.healthInnovationNature.name}_${index}_${item.id}`}
                                name={`${formSchema.healthInnovation.healthInnovationNature.name}_${index}_${item.id}`}
                                control={control}
                                rules={isValidators(
                                  formSchema.healthInnovation.healthInnovationNature.validators
                                )}
                                defaultValue={item.healthInnovationNature}
                                render={(props) => {
                                  return (
                                    <CheckboxGroup
                                      value={props.value || []}
                                      onChange={(value, checked, e) => {
                                        props.onChange(value)
                                      }}
                                    >
                                      {formSchema.healthInnovation.healthInnovationNature.options.map(
                                        (item, index) => {
                                          return (
                                            <Checkbox
                                              value={item.value}
                                              disabled={item.disabled}
                                              key={index}
                                            >
                                              {item.label}
                                            </Checkbox>
                                          )
                                        }
                                      )}
                                    </CheckboxGroup>
                                  )
                                }}
                              />
                            </>
                          ) : (
                            <>
                              {Array.isArray(item.healthInnovationNature) ? (
                                item.healthInnovationNature.map((value, index) => (
                                  <React.Fragment key={index}>
                                    {index > 0}
                                    <p>
                                      <Icon
                                        icon="check-square-o"
                                        style={{ marginRight: 5, color: '#14997a' }}
                                      />
                                      {getValueFromOptions(
                                        formSchema.healthInnovation.healthInnovationNature.options.map(
                                          (item) => ({
                                            ...item,
                                            value: item.value.toString(),
                                          })
                                        ),
                                        value
                                      )}
                                    </p>
                                  </React.Fragment>
                                ))
                              ) : (
                                <p>
                                  <Icon
                                    icon="check-square-o"
                                    style={{ marginRight: 5, color: '#14997a' }}
                                  />
                                  {getValueFromOptions(
                                    formSchema.healthInnovation.healthInnovationNature.options.map(
                                      (item) => ({
                                        ...item,
                                        value: item.value.toString(),
                                      })
                                    ),
                                    item.healthInnovationNature || '0'
                                  )}
                                </p>
                              )}
                            </>
                          )}
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>
                    )}
                    {formSchema?.healthInnovation?.healthInnovationDetail && (
                      <Row style={{ marginTop: 10 }}>
                        <Col lg={22} md={22} sm={22} xs={22}>
                          {!disabled ? (
                            <>
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    formSchema.healthInnovation.healthInnovationDetail.validators
                                  ) && 'required'
                                )}
                              >
                                {formSchema.healthInnovation.healthInnovationDetail.label}
                              </ControlLabel>
                              <InputForm
                                schema={formSchema.healthInnovation.healthInnovationDetail}
                                name={`${formSchema.healthInnovation.healthInnovationDetail.name}_${index}_${item.id}`}
                                value={item.healthInnovationDetail}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                                hideLabel={true}
                                componentClass="textarea"
                              />
                            </>
                          ) : (
                            <>
                              <b> {formSchema.healthInnovation.healthInnovationDetail.label}</b>
                              <p>{item.healthInnovationDetail}</p>
                            </>
                          )}
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>
                    )}
                    {formSchema?.healthInnovation?.healthInnovationUtilization && (
                      <Row style={{ marginTop: 10 }}>
                        <Col lg={22} md={22} sm={22} xs={22}>
                          {!disabled ? (
                            <>
                              <ControlLabel
                                className={classNames(
                                  isRequired(
                                    formSchema.healthInnovation.healthInnovationUtilization
                                      .validators
                                  ) && 'required'
                                )}
                              >
                                {formSchema.healthInnovation.healthInnovationUtilization.label}
                              </ControlLabel>
                              <InputForm
                                schema={formSchema.healthInnovation.healthInnovationUtilization}
                                name={`${formSchema.healthInnovation.healthInnovationUtilization.name}_${index}_${item.id}`}
                                value={item.healthInnovationUtilization}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                                hideLabel={true}
                                componentClass="textarea"
                              />
                            </>
                          ) : (
                            <>
                              <b>{formSchema.healthInnovation.healthInnovationUtilization.label}</b>
                              <p>{item.healthInnovationUtilization}</p>
                            </>
                          )}
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>
                    )}
                    {formSchema?.healthInnovation?.healthInnovationFiles && (
                      <Row style={{ marginTop: 10 }}>
                        <Col lg={22} md={22} sm={22} xs={22}>
                          <ControlLabel
                            className={classNames(
                              isRequired(
                                formSchema.healthInnovation.healthInnovationFiles.validators
                              ) && 'required'
                            )}
                          ></ControlLabel>
                          <ErrorMessage
                            error={errors[formSchema.healthInnovation.healthInnovationFiles.name]}
                          />
                          {isReadOnly != true ? (
                            <Controller
                              key={formSchema.healthInnovation.healthInnovationFiles.name}
                              name={`${formSchema.healthInnovation.healthInnovationFiles.name}_${index}_${item.id}`}
                              control={control}
                              defaultValue={item.healthInnovationFiles}
                              value={item.healthInnovationFiles}
                              render={(props) => {
                                return (
                                  <>
                                    <Uploader
                                      accept={
                                        formSchema.healthInnovation.healthInnovationFiles
                                          .fileType || '.jpg, .jpeg, .png, .pdf'
                                      }
                                      autoUpload={false}
                                      disabled={
                                        formSchema.healthInnovation.healthInnovationFiles.disabled
                                      }
                                      fileListVisible={true}
                                      listType="picture-text"
                                      fileList={
                                        typeof props.value === 'string' ? [] : props.value || []
                                      }
                                      onChange={(fileList) => {
                                        if (isEmpty(fileList)) {
                                          props.onChange(undefined)
                                        } else {
                                          let file = fileList[fileList.length - 1]

                                          if (
                                            file.blobFile.size >
                                            (formSchema?.healthInnovation?.healthInnovationFiles
                                              ?.fileSize || defaultMaxFileSize) *
                                              1024 *
                                              1024
                                          ) {
                                            notification.open('error', {
                                              title: `ขนาดไฟล์เกิน ${
                                                formSchema?.healthInnovation?.healthInnovationFiles
                                                  ?.fileSize || defaultMaxFileSize
                                              } MB`,
                                              duration: 5000,
                                            })
                                            return
                                          }

                                          if (isImageOrPdf(file.blobFile.type)) {
                                            props.onChange(fileList)
                                            setFileTypeError(false)
                                          } else {
                                            setFileTypeError(true)
                                            notification.open('error', {
                                              title:
                                                'ชนิดที่รองรับ ' +
                                                  formSchema?.healthInnovation
                                                    ?.healthInnovationFiles?.fileType ||
                                                '.jpg, .jpeg, .png, .pdf',
                                              duration: 5000,
                                            })
                                          }
                                        }
                                      }}
                                      draggable
                                    >
                                      <div>
                                        <div
                                          style={{ lineHeight: '50px' }}
                                          className={classNames(
                                            'uploader',
                                            `${theme[0]}-background`
                                          )}
                                        >
                                          <Icon size="4x" icon="upload2" />
                                          <small className="uploder__text">
                                            {/* <p style={{ wordBreak: 'break-word' }}>
                                              {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf ขนาดไฟล์ไม่เกิน 50 MB`}
                                            </p> */}
                                            <p style={{ wordBreak: 'break-word' }}>
                                              {`คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : ${
                                                formSchema?.healthInnovation?.healthInnovationFiles
                                                  ?.fileType || '.jpg, .jpeg, .png, .pdf'
                                              } , ขนาดไฟล์ไม่เกิน ${
                                                formSchema?.healthInnovation?.healthInnovationFiles
                                                  ?.fileSize || defaultMaxFileSize
                                              } MB`}
                                            </p>
                                          </small>
                                        </div>
                                      </div>
                                    </Uploader>
                                    {props.value && typeof props.value == 'string' && (
                                      <DownloadButton
                                        //disabled={!subItem.value}
                                        onClick={() => {
                                          onDownload(props.value, 'เอกสารแนบ')
                                        }}
                                      />
                                    )}
                                  </>
                                )
                              }}
                            />
                          ) : (
                            <>
                              {formSchema?.healthInnovation?.values?.length > 0 && (
                                <>
                                  <IncomeRecordFileTable
                                    data={formSchema?.healthInnovation?.values}
                                    deleteable={false}
                                  />
                                </>
                              )}
                            </>
                          )}
                        </Col>
                        {!disabled ? (
                          <Col lg={2} md={2} sm={2} xs={2}>
                            {progressFilesValue.length > 1 && (
                              <div style={{ marginTop: 33 }}>
                                <Button color="red" onClick={() => handleDelete(item, index)}>
                                  ลบ
                                </Button>
                              </div>
                            )}
                            {progressFilesValue.length == index + 1 && (
                              <>
                                <div style={{ marginTop: 33 }}>
                                  <Button color="blue" onClick={() => handleAdd()}>
                                    เพิ่ม
                                  </Button>
                                </div>
                              </>
                            )}
                          </Col>
                        ) : (
                          <Col lg={2} md={2} sm={2} xs={2}></Col>
                        )}
                      </Row>
                    )}
                  </Panel>
                </>
              )
            })}
        </div>
        {!disabled && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  บันทึก
                </SaveButton>
              </div>
            </Col>
          </Row>
        )}
      </Panel>
    </div>
  )
}
